export const statisticsLabels = ['Insightfulness', 'Relevance', 'Politeness'];

export const filterTags = [
  { id: 0, label: 'All' },
  { id: 1, label: 'News' },
  { id: 2, label: 'Politics' },
  { id: 3, label: 'The Arts' },
  { id: 4, label: 'Sports' },
  { id: 5, label: 'Fun' },
  { id: 6, label: 'Help' },
  // {id: 7, label: 'Following'},
  // { id: 7, label: 'Monitoring' },
];
